import { Box, Modal } from '@mui/material';
import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTableRow
} from '@components/Styles/TableStyle';
import {
  CustomTextField,
  RequiredMark,
} from '@components/Styles/CommonStyle';
import React from 'react';
import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import DaumPostcodeEmbed from 'react-daum-postcode';


const CompanyAccountCreateAddress = React.memo(({ param, handleOpen, handleClose, handleComplete, setParam, open }) => {

  return (
    <React.Fragment>
        <CustomTableRow>
        <CustomHeaderCell>
        <RequiredMark />
        주소
        </CustomHeaderCell>
        <CustomBodyCell colSpan={3}>
        <CustomStack sx={{ mb: 0.5 }}>
            <CustomTextField
            width="auto"
            placeholder="우편번호"
            inputProps={{ readOnly: true }}
            disabled={true}
            value={param.zonecode}
            />
            <CustomButton size="small" onClick={handleOpen}>
            우편번호 찾기
            </CustomButton>

            <Modal open={open} onClose={handleClose}>
            <Box>
                <DaumPostcodeEmbed onComplete={handleComplete} autoClose />
            </Box>
            </Modal>
        </CustomStack>
        <CustomStack>
            <CustomTextField
            sx={{ mb: 0.5 }}
            maxWidth="unset"
            placeholder="기본주소"
            inputProps={{ readOnly: true }}
            disabled={true}
            value={param.address}
            />
        </CustomStack>
        <CustomStack>
            <CustomTextField
            placeholder="상세주소"
            maxWidth="unset"
            value={param.detailAddress}
            onChange={(e) => setParam({ ...param, detailAddress: e.target.value })}
            />
        </CustomStack>
        </CustomBodyCell>
        </CustomTableRow>
    </React.Fragment>
  );
});

export default CompanyAccountCreateAddress;

